/// <reference path="../_references.ts"/>

module App.Administrative.UploadPhotos {
	import TitleBarService = App.Helpers.TitleBarService;
	import UploadService = App.Helpers.UploadService;
	import Appointment = App.Appointments.Appointment;
	import SelectedAppointment = App.Appointments.SelectedAppointment;
	import DefaultToasts = App.Utils.DefaultToasts;
	import OrganizationFileUploadData = App.Utils.OrganizationFileUploadData;

	export class UploadPhotosController {
		loading: boolean = true;
		savingImage: boolean = false;
		errorFile: Object = {};
		photos: ServiceRequestPhoto[];
		appointment: Appointment = null;
		organization: OrganizationFileUploadData = null;

		showMdl: boolean = true;
		static $inject: string[] = ['$rootScope', 'AdministrativeService', 'SelectedAppointment', 'TitleBarService',
			'$timeout', 'UploadService', 'DefaultToasts', 'OrganizationService'];

		constructor(
			private $rootScope: AppRootScope,
			private AdministrativeService: AdministrativeService,
			protected SelectedAppointment: SelectedAppointment,
			private TitleBarService: TitleBarService,
			private $timeout: ng.ITimeoutService,
			private UploadService: UploadService,
			private DefaultToasts: DefaultToasts,
			private OrganizationService: App.Utils.OrganizationService
		) {
			TitleBarService.set('Appointment');

			OrganizationService.getFileUploadDetails().then((organization) => {
				this.organization = organization.data;
			});

			SelectedAppointment.getAppointment().then((appointment) => {
				this.setAppointment(appointment);
			});
		}

		setAppointment(appointment: Appointment) {
			this.appointment = appointment;

			this.AdministrativeService.GetServiceRequestPhotos(this.appointment.service_request.id).then((response) => {
				this.photos = response.data;
				this.loading = false;
				this.upgradeMdlInputs();
			});
		}

		savePhotoDetails() {
			this.photos.forEach(photo => {
				this.savingImage = true;
				this.AdministrativeService.UpdateServiceRequestPhotos(this.appointment.service_request.id, photo).then(() => {
					this.DefaultToasts.displaySuccess('File saved');
				}).finally(() => this.savingImage = false);
			});
		}

		deleteImage($index: number, image: ServiceRequestPhoto) {
			this.AdministrativeService.DeleteServiceRequestPhoto(this.appointment.service_request.id, image.id).then(() => {
				this.photos.splice($index, 1);
			});
		};

		displayMaxSizeError() {
			this.DefaultToasts.displayWarning('Reduce File Size and Try Again');
			this.errorFile = {};
		};

		uploadImage(files: File[]) {
			let count: number = 0,
				uploadedCount: number = 0,
				srId: number = this.appointment.service_request.id;

			files.forEach((file) => {
				let filetype = file.type.split('/'),
					time = new Date().getTime(),
					filename = this.organization.id + '/' + srId + '/' + this.$rootScope.app.generateGuid() +
						'.' + time + '.' + file.name.split('.').pop();

				count++;
				this.DefaultToasts.displayLoading('File ' + count + '/' + files.length + ' uploading');
				this.savingImage = true;
				this.UploadService.uploadAWS('service-request-image-uploads', filename, file).then((response: any) => {
					let data = {
						url: response.headers('Location'),
						size: file.size,
						file_type: filetype[0] === 'application' ? filetype[1] : filetype[0]
					};

					this.AdministrativeService.addImages(srId, data).then((images) => {
						this.photos.unshift(images.data);
						this.upgradeMdlInputs();
						uploadedCount++;

						if (count === uploadedCount) {
							this.savingImage = false;
							this.DefaultToasts.hideLoading();
							this.DefaultToasts.displaySuccess('File ' + count + '/' + files.length + ' uploaded');
						}
					});
				})
				.catch((err) => this.DefaultToasts.displayError(err, 'Failed to upload file: '));
			});
		};

		upgradeMdlInputs() {
			this.showMdl = false;
			this.$timeout(() => {
				this.showMdl = true;
				this.$timeout(() => {
					componentHandler.upgradeAllRegistered();
				})
			});
		}
	}
}